// import "./frontend.scss"

import React, { useState, useEffect, useMemo } from "react"
import axios from "axios";
import Pagination from '@material-ui/lab/Pagination';
import OurComponent from "../search_filter/frontend_filter_page";
import MainHeaderSection from "./sections/MainHeaderSection";
import HeaderMobileMenu from "./sections/HeaderMobileMenu";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import Spinner from 'react-bootstrap/Spinner';


var marker_details = [];
var map;
function Rem_filter_page(props) {


    const { t, i18n } = useTranslation('common');
    const [windowSize, setWindowSize] = useState(getWindowSize());
    const [isLoad, setIsLoad] = useState(true);

    var count = 0;
    useEffect(() => {
        count = 1;
        function handleWindowResize() {
            setWindowSize(getWindowSize());
        }
        window.addEventListener('resize', handleWindowResize);
        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);
    useEffect(() => {
        function handleWindowResize() {
            setWindowSize(getWindowSize());
        }

        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, []);
    // const [select_value1, setSelectValue1] = useState('')
    const [paginationData, setPaginationData] = useState('')
    const [select_value2, setSelectValue2] = useState('')
    let [select_valueID1, setSelectValueID1] = useState('')
    let [select_valueID2, setSelectValueID2] = useState('')
    const [trades_data, setTradesData] = useState([]);
    const [locations_data, setLocationData] = useState([]);
    const [postData, setPostData] = useState([]);
    const [postMetaData, setPostMetaData] = useState({});
    const [quickFilterData, setQuickFilterData] = useState({});
    var [checkedQuickFilterData, setCheckedQuickFilterData] = useState([]);

    const [showLocationComponent, setShowLocationComponent] = useState(false);
    const [showFilterComponent, setShowFilterComponent] = useState(false);

    useEffect(() => {

        if (props?.lan == 'en') {
            i18next.changeLanguage("en");
        } else {
            i18next.changeLanguage("el");
        }
        setPaginationData(props?.data?.paginationData);
        setPostData(props?.data?.data);

        setQuickFilterData(props?.quickFilter?.data);
        document.getElementsByClassName('skeleton-container')[0].remove();
        setTimeout(function () {
            initMap();
        }, 3000);


    }, []);

    // console.log(setMapToFixed1());
    function closeSearchModel() {
        document.getElementsByClassName('mobile_serach_module')[0].style.display = "none";
    }

    function closeMapModel() {
        document.getElementsByClassName('mobile_map_module')[0].style.display = "none";
    }
    // jQuery(document).on('click', '.rem_preminum', function (event) {
    //    console.log(event.target.id )
    //     if(event.target.id  !="rem_link_url"){
    //        
    //      // window.location.href = dataurl;
    //     }

    // });

    jQuery(document).on('click', '.rem_preminum', function (e) {
        var clickedOn = jQuery(e.target);
        if (!clickedOn.parents().andSelf().is('.Es-see-more a') && !clickedOn.parents().andSelf().is('.notClick')) {
            var dataurl = jQuery(this).data('value');
            //  jQuery(".rem_preminum").css({cursor: "pointer"});
            window.location.href = dataurl;
        }
    });

    // $('body').click(function(e){
    //     var clickedOn = $(e.target);
    //     if (clickedOn.parents().andSelf().is('#foo')){
    //         console.log( "Clicked on", clickedOn[0], "inside the div" );
    //     }else{
    //         console.log( "Clicked outside the div" );
    // });

    function getWindowSize() {
        const { innerWidth, innerHeight } = window;
        return { innerWidth, innerHeight };
    }

    function get_address(address) {
        try {
            // let rem_services = address;
            const data = JSON.parse(address);
            if (data[0]) {
                return data[0];
            }
        } catch (e) {
            return address;
        }
    }

    function get_phone(phone) {
        try {
            const data = JSON.parse(phone);
            if (data[0]) {
                return data[0];
            }
        } catch (e) {
            return phone;
        }
    }

    var icon1 = props.site_url + "/wp-content/uploads/2022/07/noun-map-pin-4966787.png";
    var icon2 = props.site_url + "/wp-content/uploads/2022/07/noun-map-pin-4966787-1.png";
    function initMap() {
        if (!window.google) {
            setTimeout(function () {
                initMap();
            }, 1000);
            return false;
        }
        if (postData?.postData !== undefined) {
            var locations = [];

            (postData?.postData !== undefined) ? Object.keys(postData?.postData).forEach(key => {
                const data = postData?.postData[key];
                const item = data?.metadata;
                if (data?.feature_image) {
                    var img = data?.feature_image;
                }
                else {

                    var img = props.site_url + "/wp-content/uploads/2022/09/dummy_user.jpg";
                }


                if (item?.rem_longitude && item?.rem_latitude) {
                    const html = '<div class="cardContainer">\
                    <div class="cardBox">\
                        <div class="cardHeader">\
                            <div class="profileImg">\
                                <img src="'+ img + '" alt="profileImg">\
                            </div>\
                            <div class="profileContent">\
                                <p class="txtBold"> <a href="'+ data?.post_url + '">' + (data?.post_title) + '</a> </p>\
                                <p class="txtOcuptn">'+ (item?.rem_tag[0]) + '</p>\
                                <address class="userAddress">'+ (get_address(item?.rem_address[0]) ? get_address(item?.rem_address[0]) : '') + '</address>\
                                <p class="ratings"><i class="bi bi-star-fill"></i>'+ ((data?.avgtotalrating) ? Number(data?.avgtotalrating).toFixed(2) : '0') + '<span class="rates">(' + (data?.all_review) + ')</span></p>\
                            </div>\
                        </div>\
                        <div class="cardFooter">\
                           </div>\
                        <div class="boxPoint">\
                        </div>\
                    </div>\
                </div>';
                    locations.push([html, parseFloat(Object.values(item?.rem_latitude)[0]), parseFloat(Object.values(item?.rem_longitude)[0]), data?.post_title]);
                } else {
                    locations.push(null);
                }
            }) : '';
            const lat_main_map = (postData?.map_location !== undefined) ? postData.map_location[0] : '4.389689148383714';
            const lng_main_map = (postData?.map_location !== undefined) ? postData.map_location[1] : '18.546299460448047';
            var center = { 'lat': parseFloat(lat_main_map), 'lng': parseFloat(lng_main_map) };
            map = new google.maps.Map(document.getElementById('googleMap'), {
                zoom: 13,
                center: center,
                mapTypeControl: false,
                // scaleControl: false,
                // zoomControl: false
                fullscreenControl: false,
                styles: [
                    {
                        "featureType": "landscape.man_made",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f7f1df"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape.natural",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#d0e3b4"
                            }
                        ]
                    },
                    {
                        "featureType": "landscape.natural.terrain",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.business",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.medical",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#fbd3da"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "transit.station.bus",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "simplified"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#ffe15f"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "color": "#efd151"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "simplified"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.text",
                        "stylers": [
                            {
                                "visibility": "simplified"
                            },
                            {
                                "color": "#686868"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "all",
                        "stylers": [
                            {
                                "visibility": "simplified"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "visibility": "simplified"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "labels.text",
                        "stylers": [
                            {
                                "visibility": "simplified"
                            },
                            {
                                "color": "#8c7f7f"
                            }
                        ]
                    },
                    {
                        "featureType": "transit.station.airport",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#cfb2db"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#00b3ff"
                            }
                        ]
                    }
                ]
            });

            var infowindow = new google.maps.InfoWindow({});
            var marker, count;
            marker_details = [];
            for (count = 0; count < locations.length; count++) {
                if (locations[count] != null) {
                    marker = new google.maps.Marker({
                        position: new google.maps.LatLng(locations[count][1], locations[count][2]),
                        map: map,
                        title: locations[count][0],
                        icon: icon1,
                        title: locations[count][3],
                    });
                    marker_details.push(marker);
                    google.maps.event.addListener(marker, 'click', (function (marker, count) {
                        return function () {
                            infowindow.setContent(locations[count][0]);
                            infowindow.open(map, marker);
                        }
                    })(marker, count));
                    google.maps.event.addListener(marker, 'mouseover', function () {
                        this.setIcon(icon2);
                    });
                    google.maps.event.addListener(marker, 'mouseout', function () {
                        this.setIcon(icon1);
                    });
                }
            }
        }
    }
    function highlightMarker(e) {
        if (!jQuery(e.target).hasClass('rem_map_places_detail')) {
            let index = jQuery(e.target).parents('.rem_map_places_detail').attr("data-index");
            if (marker_details[index]) {
                marker_details[index].setIcon(icon2);

                if (!map.getBounds().contains(marker_details[index].getPosition())) {
                    map.panTo(marker_details[index].getPosition());
                }
            }
        } else {
            let index = e.target.getAttribute("data-index");
            if (marker_details[index]) {
                marker_details[index].setIcon(icon2);

                if (!map.getBounds().contains(marker_details[index].getPosition())) {
                    map.panTo(marker_details[index].getPosition());
                }
            }
        }

    }
    function removeHighlightMarker(e) {
        if (!jQuery(e.target).hasClass('rem_map_places_detail')) {
            let index = jQuery(e.target).parents('.rem_map_places_detail').attr("data-index");
            if (marker_details[index]) {
                marker_details[index].setIcon(icon1);
            }
        } else {
            let index = e.target.getAttribute("data-index");
            if (marker_details[index]) {
                marker_details[index].setIcon(icon1);
            }
        }
    }
    function openPostSinglePage(e) {
        let index = e.target.getAttribute("data-index");
    }

    function handleChangePagination(e, page) {
        window.scrollTo(0, 0);

        if (props.Dtrade_name) {
            jQuery(e.target).hasClass('MuiPagination-ul');
            jQuery(e.target).parent().find('li').find('button').addClass("fa fa-spinner fa-spin");

            const data3 = document.getElementsByClassName('mobile_location_data')[0].getAttribute('SelectValueID');
            const data4 = document.getElementsByClassName('mobile_trade_data')[0].getAttribute('SelectValueID');
            var url_2 = props.site_url + (props?.lan ? '/' + props?.lan : '') + "/wp-json/myapi/v1/get_post?trade_name=" + (data4 ? data4 : props.trade_name) + "&location_name=" + (data3 ? data3 : props.location_name) + "&paged=" + page + '&quickFilter=' + checkedQuickFilterData.toString();

            if (url_2) {
                var data = axios.get(url_2).then((response) => {
                    //  console.log(response);
                    setPaginationData(response?.data?.paginationData);
                    setPostData(response?.data?.data);
                    reloadURL();
                    window.scrollTo(0, 0);

                });
            }

        }
        else {

            const data2 = document.getElementsByClassName('rem_location_input')[0].getAttribute('SelectValueID');
            const data1 = document.getElementsByClassName('rem_trade_input')[0].getAttribute('SelectValueID');
            var url_1 = props.site_url + (props?.lan ? '/' + props?.lan : '') + "/wp-json/myapi/v1/get_post?trade_name=" + (data2 ? data2 : props.trade_name) + "&location_name=" + (data1 ? data1 : props.location_name) + "&paged=" + page + '&quickFilter=' + checkedQuickFilterData.toString();
            var data = axios.get(url_1).then((response) => {
                setPaginationData(response?.data?.paginationData);
                setPostData(response?.data?.data);
                reloadURL();
                window.scrollTo(0, 0);

            });
        }






    }
    function reloadURL() {
        let data1;
        let data2;
        if (document.getElementsByClassName('rem_location_input') && document.getElementsByClassName('rem_location_input')[0]) {
            data2 = document.getElementsByClassName('rem_location_input')[0].getAttribute('SelectValueID');
        }

        if (document.getElementsByClassName('rem_trade_input') && document.getElementsByClassName('rem_trade_input')[0]) {
            data1 = document.getElementsByClassName('rem_trade_input')[0].getAttribute('SelectValueID');
        }
        if (data1 && data2) {
            window.history.pushState('', '', props.site_url + '/' + (data2 ? data2 : props.trade_name) + '/' + (data1 ? data1 : props.location_name));
        }
    }
    function quickFilterDataChange(e) {
        if (e.target.checked) {
            checkedQuickFilterData.push(e.target.value);
            setCheckedQuickFilterData(checkedQuickFilterData);
        } else {
            checkedQuickFilterData = arrayRemove(checkedQuickFilterData, e.target.value);
            setCheckedQuickFilterData(checkedQuickFilterData);
        }
        redirect_tosearch_page_quickfilter();
    }
    function redirect_tosearch_page_quickfilter() {
        if (document.getElementsByClassName('rem_trade_input') && document.getElementsByClassName('rem_trade_input')[0] && !(select_valueID1)) {
            select_valueID1 = document.getElementsByClassName('rem_trade_input')[0].getAttribute('SelectValueID');
        } else if (document.getElementsByClassName('mobile_trade_data') && !(select_valueID1)) {
            select_valueID1 = document.getElementsByClassName('mobile_trade_data')[0].getAttribute('SelectValueID');
        }
        if (document.getElementsByClassName('rem_location_input') && document.getElementsByClassName('rem_location_input')[0] && !(select_valueID2)) {
            select_valueID2 = document.getElementsByClassName('rem_location_input')[0].getAttribute('SelectValueID');
        } else if (document.getElementsByClassName('mobile_location_data') && !(select_valueID2)) {
            select_valueID1 = document.getElementsByClassName('mobile_location_data')[0].getAttribute('SelectValueID');
        }
        var url_1 = props.site_url + (props?.lan ? '/' + props?.lan : '') + "/wp-json/myapi/v1/get_post?trade_name=" + (select_valueID2 ? select_valueID2 : props.trade_name) + "&location_name=" + (select_valueID1 ? select_valueID1 : props.location_name) + '&quickFilter=' + checkedQuickFilterData.toString();;
        var data1 = axios.get(url_1).then((response) => {
            setPaginationData(response?.data?.paginationData);
            setPostData(response?.data?.data);
            reloadURL();
        });
    }
    function arrayRemove(arr, value) {
        return arr.filter(function (data) {
            return data != value;
        });
    }

    function setphoneValue(e) {

        if (!jQuery(e.target).hasClass('esborder')) {
            jQuery(e.target).parent().find('a').show().css('display', 'inline-block');
            jQuery(e.target).parent().find('span').hide();
        }
        if (!jQuery(e.target).parent().find('span').hasClass('rem_phone_icon')) {
            jQuery(e.target).parent().parent().find('a').show().css('display', 'inline-block');
            jQuery(e.target).parent().parent().find('span').hide();
        }
    }

    function OenMobileModule(bool) {
        if (!showLocationComponent) {
            var url_1 = props.site_url + (props?.lan ? '/' + props?.lan : '') + "/wp-json/myapi/v1/get_taxonomy?texonomy=QuickFilters";
            var data1 = axios.get(url_1).then((response) => {
                setQuickFilterData(response?.data?.data);
            });
            setShowLocationComponent(bool);
            setShowFilterComponent(bool);
        }
    }

    function print_company_description() {

        // console.log(props);

    }

    return (<div>


        {
            (!(postData?.postData?.length)) && initMap()
        }
        {(windowSize.innerWidth > 650) ?
            <MainHeaderSection lan={props.lan} location_data={props.location_data} trade_data={props.trade_data} location_name={props.location_name} site_url={props.site_url} trade_name={props.trade_name} Dlocation_name={props.Dlocation_name} Dtrade_name={props.Dtrade_name}></MainHeaderSection>
            :
            <div>
                <MainHeaderSection lan={props.lan} mobile_map_module={showLocationComponent} onChange={OenMobileModule} map_area1="true" location_name={props.location_name} site_url={props.site_url} trade_name={props.trade_name} Dlocation_name={props.Dlocation_name} Dtrade_name={props.Dtrade_name}></MainHeaderSection>
                <HeaderMobileMenu site_url={props?.site_url}></HeaderMobileMenu>
                <section class="module_section mobile_map_module">
                    <div class="module">
                        {/* <div class="module_close"> 
                            <img src="/wp-content/uploads/2022/09/cancel.png" onClick={closeMapModel} />
                        </div> */}
                        {
                            (showLocationComponent) && (
                                <MainHeaderSection lan={props.lan} Dlocation_name={props.Dlocation_name} Dtrade_name={props.Dtrade_name} location_name={props.location_name} trade_name={props.trade_name} site_url={props.site_url} map_area1="true" map_area="true"></MainHeaderSection>
                            )
                        }
                        <div class="map-img" id="googleMap"></div>
                        {/* <button class="searchfilterbtn_moudel">Search</button> */}
                    </div>
                </section>

                <section class="module_section mobile_serach_module">
                    <div class="module">
                        <div class="module_close">
                            <img src="/wp-content/uploads/2022/09/cancel.png" onClick={closeSearchModel} />
                        </div>
                        {/* <div class="Search_heading_module">
                            <h2>Search Now and find the best one today!</h2>
                        </div> */}
                        {
                            (showFilterComponent) && (
                                <OurComponent version1="version1" trade_data={props?.trade_data} location_data={props?.location_data} lan={props.lan} Dlocation_name={props.Dlocation_name} Dtrade_name={props.Dtrade_name} location_name={props.location_name} trade_name={props.trade_name} site_url={props.site_url}></OurComponent>
                            )
                        }

                        {/* <button class="searchfilterbtn_moudel">Search</button> */}
                    </div>
                </section>
            </div>
        }

        <section>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-6 category-list_right_section p-0">
                        <div class={(windowSize.innerWidth <= 650) ? "filter_wrapper mobile_filter_wrapper" : "filter_wrapper"}>

                            {/* <div class="quick-filters mt-3">
                                <div class="row">
                                    <div class="col-md-12">

                                        <h6 class="text-primary Es-Quick-filters">{t('Quick Filters')}</h6>
                                    </div>
                                    {(Object.keys(quickFilterData).length !== 0) && quickFilterData.map(function (object, i) {
                                        return (<div class="col-md-4">
                                            <div class="form-check">
                                                <input type="checkbox" class="form-check-input" onChange={quickFilterDataChange} name="" id={object.slug} value={object.term_id} />
                                                <label class="form-check-label text-primary Es-check-txt" for={object.slug}>{object.name}</label>
                                            </div>
                                        </div>);
                                    })}
                                </div>
                            </div> */}
                        </div>


                        <div class="row mt-4">
                            <div class="col-md-12">

                                {(paginationData.totalRecords || paginationData.totalRecords == 0) ? (

                                    <h1 class="text-primary Es-main-title">{postData?.trade_name_} {postData?.location_name_}</h1>
                                ) : (
                                    ''
                                )
                                }
                            </div>
                        </div>
                        <div class="skeleton-container">
                            <div class="skeleton-row">
                                <div class="skeleton-col-12">
                                    <div class="skeleton-heading-box bg-color"></div>
                                </div>
                                <div class="skeleton-col-2">
                                    <div class="skeleton-img-box bg-color"></div>
                                </div>
                                <div class="skeleton-col-8">
                                    <div class="skeleton-content-box bg-color"></div>
                                    <div class="skeleton-heading-box bg-color"></div>
                                </div>
                                <div class="skeleton-col-3">
                                    <div class="skeleton-content-box bg-color"></div>
                                </div>
                                <div class="skeleton-col-8">
                                    <div class="skeleton-content-box bg-color"></div>
                                </div>
                                <div class="skeleton-col-12">
                                    <div class="skeleton-lgcontent-box bg-color"></div>
                                </div>
                                <div class="skeleton-col-3">
                                    <div class="skeleton-btn-content-box bg-color"></div>
                                </div>
                                <div class="skeleton-col-3">
                                    <div class="skeleton-btn-content-box bg-color"></div>
                                </div>
                                <div class="skeleton-col-3">
                                    <div class="skeleton-btn-content-box bg-color"></div>
                                </div>
                            </div>
                        </div>

                        <div class="filter_search_ads" dangerouslySetInnerHTML={{ __html: window.rem_filter_page_ads.replace(/&nbsp;/g, '<br />') }} ></div>
                        {postData?.postData && postData?.postData.map(function (object, i) {
                            const metadata = object?.metadata;
                            const content_id = object?.ID;
                            let is_preminum = 'rem_free';
                            let baseClass = "mobile-content__sec col-xl-9 col-lg-9 col-md-9 col-sm-9 col-12"
                            if (metadata?.rem_premium && metadata.rem_premium[0] == 'yes') {
                                baseClass = "mobile-content__sec col-xl-9 col-lg-9 col-md-9 col-sm-9 col-8"
                                is_preminum = 'rem_preminum';
                            }


                            if (postData?.postData.length == i + 1) {
                                initMap();
                                count = 0;
                            }
                            return <div data-value={object.post_url} data-distance={object?.distance} class={is_preminum + " row card-section rem_map_places_detail"} data-id={object.ID} data-index={i} onMouseEnter={highlightMarker} onMouseLeave={removeHighlightMarker}>
                                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-4">
                                    {
                                        (metadata?.rem_premium && metadata.rem_premium[0] == 'yes') ?
                                            <a href={object.post_url}>
                                                {(object.feature_image) ?
                                                    <img class="brand-logo" src={object.feature_image} />
                                                    : <img class="brand-logo" src={props.site_url + "/wp-content/uploads/2022/09/dummy_user.jpg"} />
                                                }
                                            </a>

                                            : ''
                                    }
                                </div>
                                <div class={baseClass} ClassName="sdfg">
                                    {
                                        (metadata?.rem_premium && metadata.rem_premium[0] == 'yes') ?

                                            <h4 class="text-primary Es-card-title text-uppercase m-0"><a href={object.post_url}>{object.post_title}</a></h4>
                                            :
                                            <h4 class="text-primary Es-card-title text-uppercase m-0">{object.post_title}</h4>

                                    }
                                    <p class="Es-para-card m-0"><b>{(metadata?.rem_tag !== undefined ? metadata?.rem_tag[0] : '') + ''}</b></p>
                                </div>
                                {
                                    (windowSize.innerWidth <= 650) ?
                                        <div class="col-md-12 mobile_details_show">
                                            <div class="inner-detail">
                                                <div class="mobile_details_show_content">
                                                    {
                                                        // (metadata?.rem_premium && metadata.rem_premium[0] == 'yes') ?
                                                        //     <h4 class="text-primary Es-card-title text-uppercase m-0"><a href={object.post_url}>{object.post_title}</a></h4>
                                                        //     :
                                                        //     <h4 class="text-primary Es-card-title text-uppercase m-0">{object.post_title}</h4>
                                                    }

                                                    {/* <p class="Es-para-card m-0"><b>{(metadata?.rem_tag !== undefined ? metadata?.rem_tag[0] : '') + ''}</b></p> */}
                                                    {
                                                        (metadata?.rem_premium && metadata.rem_premium[0] == 'yes') ?
                                                            <p class="text-primary mt-2 mb-0 star-rating ">
                                                                <span class="rateNum"><b>


                                                                    {(object?.avgtotalrating) ?
                                                                        Number(object?.avgtotalrating).toFixed(2)
                                                                        : ''
                                                                    }
                                                                </b></span>
                                                                <span class="ratingsStar">

                                                                    <div class="rem_Stars" style={{ '--rating': Number(object?.avgtotalrating).toFixed(2) }}>
                                                                    </div>

                                                                </span>
                                                                ({(object?.all_review) ? (object?.all_review + '') : ('0')})
                                                            </p>
                                                            : ''
                                                    }
                                                    {
                                                        get_phone((metadata?.rem_address) ? metadata?.rem_address[0] : '') ?
                                                            <p class="m-0 Es-star-rating rem_loction_img"><img class="rem_address_img" src={props.site_url + "/wp-content/uploads/2023/03/address-1.svg"} /> {((metadata?.rem_address !== undefined) ?
                                                                get_address(metadata?.rem_address[0])
                                                                : ''
                                                            )}
                                                            </p>
                                                            : ''
                                                    }


                                                    {
                                                        (metadata?.rem_premium && metadata.rem_premium[0] == 'yes') ?

                                                            <p class="mt-2 mb-2 electrician_paira content" dangerouslySetInnerHTML={{ __html: window.map_description[content_id] }} ></p>
                                                            //<p class="mt-2 mb-2 electrician_paira">{((metadata?.map_description?.[0]) ? metadata?.map_description?.[0].replace(/(<([^>]+)>)/ig, '') : '')}</p>
                                                            : ''
                                                    }
                                                    {/* {
                                                        (window.map_description[content_id]) ?
                                                            <p class="mt-2 mb-2" dangerouslySetInnerHTML={{ __html: window.map_description[content_id] }} ></p>
                                                            : ''
                                                    } */}


                                                </div>

                                                {
                                                    (metadata?.rem_premium && metadata.rem_premium[0] == 'yes') ?

                                                        <p class="m-0 Es-see-more" id="rem_link_url" data-value="test_url_link">

                                                            {

                                                                get_phone((metadata?.rem_phone) ? metadata?.rem_phone[0] : '') ?

                                                                    <span class="notClick esborder phone_span_rem" >

                                                                        <a href={'tel:' + get_phone((metadata?.rem_phone) ? metadata?.rem_phone[0] : '')} >
                                                                            <span class="rem_phone_icon">
                                                                                <img src={props.site_url + '/wp-content/uploads/2023/03/phone.svg'} class="rem_phonevalue" value={get_phone((metadata?.rem_phone) && metadata?.rem_phone[0])} />
                                                                            </span>
                                                                            {get_phone((metadata?.rem_phone) ? metadata?.rem_phone[0] : '')}
                                                                        </a>

                                                                    </span>
                                                                    : <span class=" esborder phone_span_rem" >

                                                                        <a >
                                                                            <span class="rem_phone_icon">

                                                                            </span>
                                                                            -----
                                                                        </a>

                                                                    </span>

                                                            }
                                                            {
                                                                get_phone((metadata?.rem_website) ? metadata?.rem_website[0] : '') ?
                                                                    <a href={((metadata?.rem_website !== undefined) ? metadata?.rem_website[0] : 'javascript:;')} target="_blank" class="border-right esborder website_rem_mobile" >
                                                                        <img src={props.site_url + '/wp-content/uploads/2023/03/website-1.svg'} class="rem_website_img" />
                                                                        WEBSITE
                                                                    </a>
                                                                    : <a class="border-right esborder website_rem_mobile">

                                                                        -----
                                                                    </a>
                                                            }
                                                            {
                                                                (metadata?.rem_email_check && metadata?.rem_email_check[0] == 'yes') ?
                                                                    <a href={'mailto:' + ((metadata?.rem_email !== undefined) ? metadata?.rem_email[0] : '')} class="esborder">
                                                                        <img src={props.site_url + '/wp-content/uploads/2023/03/email-1.svg'} class="rem_mail_img" />
                                                                        EMAIL
                                                                    </a>
                                                                    : <a class="esborder">

                                                                        -----
                                                                    </a>
                                                            }
                                                        </p>
                                                        : <p class="m-0 Es-see-more" id="rem_link_url" data-value="test_url_link">
                                                            {

                                                                get_phone((metadata?.rem_phone) ? metadata?.rem_phone[0] : '') ?

                                                                    <span class="notClick esborder phone_span_rem" >

                                                                        <a href={'tel:' + get_phone((metadata?.rem_phone) ? metadata?.rem_phone[0] : '')} >
                                                                            <span class="rem_phone_icon">
                                                                                <img src={props.site_url + '/wp-content/uploads/2023/03/phone.svg'} class="rem_phonevalue" value={get_phone((metadata?.rem_phone) && metadata?.rem_phone[0])} />
                                                                            </span>
                                                                            {get_phone((metadata?.rem_phone) ? metadata?.rem_phone[0] : '')}
                                                                        </a>

                                                                    </span>
                                                                    : <span class=" esborder phone_span_rem" >

                                                                        <a >
                                                                            <span class="rem_phone_icon">

                                                                            </span>
                                                                            -----
                                                                        </a>

                                                                    </span>

                                                            }
                                                            {
                                                                get_phone((metadata?.rem_website) ? metadata?.rem_website[0] : '') ?
                                                                    <a href={((metadata?.rem_website !== undefined) ? metadata?.rem_website[0] : 'javascript:;')} class="border-right esborder website_rem_mobile" target="_blank">
                                                                        <img src={props.site_url + '/wp-content/uploads/2023/03/website-1.svg'} class="rem_website_img" />
                                                                        WEBSITE
                                                                    </a>
                                                                    : <a class="border-right esborder website_rem_mobile">

                                                                        -----
                                                                    </a>
                                                            }
                                                            {
                                                                (metadata?.rem_email_check && metadata?.rem_email_check[0] == 'yes') ?
                                                                    <a href={'mailto:' + ((metadata?.rem_email !== undefined) ? metadata?.rem_email[0] : '')} class="esborder">
                                                                        <img src={props.site_url + '/wp-content/uploads/2023/03/email-1.svg'} class="rem_mail_img" />
                                                                        EMAIL
                                                                    </a>
                                                                    : <a class="esborder">

                                                                        -----
                                                                    </a>
                                                            }
                                                        </p>
                                                }
                                            </div>
                                        </div>
                                        :
                                        <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-8 mobile_padding">
                                            <div class="inner-detail">
                                                {
                                                    (metadata?.rem_premium && metadata.rem_premium[0] == 'yes') ?
                                                        <h4 class="text-primary Es-card-title text-uppercase m-0"><a href={object.post_url}>{object.post_title}</a></h4>
                                                        :
                                                        <h4 class="text-primary Es-card-title text-uppercase m-0">{object.post_title}</h4>
                                                }

                                                <p class="Es-para-card m-0"><b>{(metadata?.rem_tag !== undefined ? metadata?.rem_tag[0] : '') + ''}</b></p>
                                                <div class="mobile_screen_hide">
                                                    {
                                                        (metadata?.rem_premium && metadata.rem_premium[0] == 'yes') ?
                                                            <p class="text-primary mt-2 mb-0 star-rating ">
                                                                <span class="rateNum"><b>


                                                                    {(object?.avgtotalrating) ?
                                                                        Number(object?.avgtotalrating).toFixed(2)
                                                                        : ''
                                                                    }
                                                                </b></span>
                                                                <span class="ratingsStar">

                                                                    <div class="rem_Stars" style={{ '--rating': Number(object?.avgtotalrating).toFixed(2) }}>
                                                                    </div>

                                                                </span>

                                                                ({(object?.all_review) ? (object?.all_review + "") : ("0")})
                                                            </p>
                                                            : ''
                                                    }
                                                    {
                                                        get_phone((metadata?.rem_address) ? metadata?.rem_address[0] : '') ?
                                                            <p class="m-0 Es-star-rating rem_loction_img"><img class="rem_address_img" src={props.site_url + "/wp-content/uploads/2023/03/address-1.svg"} /> {((metadata?.rem_address !== undefined) ?
                                                                get_address(metadata?.rem_address[0])
                                                                : ''
                                                            )}
                                                            </p>
                                                            : ''
                                                    }

                                                    {
                                                        (metadata?.rem_premium && metadata.rem_premium[0] == 'yes') ?

                                                            <p class="m-0 Es-see-more" id="rem_link_url" data-value="test_url_link">
                                                                {
                                                                    get_phone((metadata?.rem_phone) ? metadata?.rem_phone[0] : '') ?

                                                                        <span class="notClick border-right esborder" onClick={setphoneValue}>

                                                                            <a class="rem_hide" href={'tel:' + get_phone((metadata?.rem_phone) ? metadata?.rem_phone[0] : '')} >  <p class="rem_userNumber">
                                                                                {get_phone((metadata?.rem_phone) && metadata?.rem_phone[0])}
                                                                            </p></a>
                                                                            <span class="rem_phone_icon">

                                                                                <img src={props.site_url + '/wp-content/uploads/2023/03/phone.svg'} class="rem_phonevalue" value={get_phone((metadata?.rem_phone) && metadata?.rem_phone[0])} />
                                                                                {t('PHONE')}
                                                                            </span>
                                                                        </span>
                                                                        : ''
                                                                }


                                                                {
                                                                    get_phone((metadata?.rem_website) ? metadata?.rem_website[0] : '') ?
                                                                        <a target="_blank" href={((metadata?.rem_website !== undefined) ? metadata?.rem_website[0] : 'javascript:;')} class="border-right esborder"  >
                                                                            <img src={props.site_url + '/wp-content/uploads/2023/03/website-1.svg'} class="rem_website_img" />
                                                                            WEBSITE
                                                                        </a>
                                                                        : ''
                                                                }
                                                                {
                                                                    (metadata?.rem_email_check && metadata?.rem_email_check[0] == 'yes') ?
                                                                        <a href={'mailto:' + ((metadata?.rem_email !== undefined) ? metadata?.rem_email[0] : '')} class="esborder">
                                                                            <img src={props.site_url + '/wp-content/uploads/2023/03/email-1.svg'} class="rem_mail_img" />
                                                                            EMAIL
                                                                        </a>
                                                                        : ''
                                                                }
                                                            </p>
                                                            : <p class="m-0 Es-see-more see_phone" id="rem_link_url" data-value="test_url_link">
                                                                {
                                                                    get_phone((metadata?.rem_phone) ? metadata?.rem_phone[0] : '') ?
                                                                        <span class="notClick border-right esborder" onClick={setphoneValue}>

                                                                            <a class="rem_hide" href={'tel:' + get_phone((metadata?.rem_phone) ? metadata?.rem_phone[0] : '')} >  <p class="rem_userNumber">
                                                                                {get_phone((metadata?.rem_phone) && metadata?.rem_phone[0])}
                                                                            </p></a>
                                                                            <span class="rem_phone_icon rem_seePhone">
                                                                                <img src={props.site_url + '/wp-content/uploads/2023/03/phone.svg'} class="rem_see_phone" />
                                                                                {t('SEE PHONE')}
                                                                            </span>
                                                                        </span>

                                                                        : ''
                                                                }
                                                                {
                                                                    get_phone((metadata?.rem_website) ? metadata?.rem_website[0] : '') ?
                                                                        <a href={((metadata?.rem_website !== undefined) ? metadata?.rem_website[0] : 'javascript:;')} class="border-right esborder" target="_blank">
                                                                            <img src={props.site_url + '/wp-content/uploads/2023/03/website-1.svg'} class="rem_website_img" />
                                                                            WEBSITE
                                                                        </a>
                                                                        : ''
                                                                }
                                                                {
                                                                    (metadata?.rem_email_check && metadata?.rem_email_check[0] == 'yes') ?
                                                                        <a href={'mailto:' + ((metadata?.rem_email !== undefined) ? metadata?.rem_email[0] : '')} class="esborder">
                                                                            <img src={props.site_url + '/wp-content/uploads/2023/03/email-1.svg'} class="rem_mail_img" />
                                                                            EMAIL
                                                                        </a>
                                                                        : ''
                                                                }
                                                            </p>
                                                    }


                                                    {
                                                        (metadata?.rem_premium && metadata.rem_premium[0] == 'yes') ?

                                                            <p class="content" dangerouslySetInnerHTML={{ __html: window.map_description[content_id] }} ></p>
                                                            // <p class="mt-2 mb-2">{((metadata?.map_description?.[0]) ? metadata?.map_description?.[0].replace(/(<([^>]+)>)/ig, '') : '')}</p>
                                                            : ''
                                                    }


                                                </div>
                                            </div>
                                        </div>
                                }
                                {/* </a> */}
                            </div>
                        })}
                        <div class="rem_pagination " >

                            {(paginationData.totalRecords) ? (

                                <Pagination variant="outlined" onChange={handleChangePagination} count={paginationData?.totalPages} defaultPage={paginationData?.currentPage} />

                            ) : (
                                ''
                            )}
                        </div>
                    </div>
                    <div class="col-md-6 p-0 googleMap_section" >
                        {/* <iframe class="map-img" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d113911.22309137874!2d80.8724727914299!3d26.848674749925312!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399bfd991f32b16b%3A0x93ccba8909978be7!2sLucknow%2C%20Uttar%20Pradesh!5e0!3m2!1sen!2sin!4v1655203466360!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" /> */}
                        {(windowSize.innerWidth > 640) && <div class="map-img" id="googleMap"></div>}


                    </div>
                </div>
            </div>
        </section>
        <div class="row trade_content">
            <div class="col-md-12">

            </div>
        </div>
    </div>);
}

export default Rem_filter_page;

